import { render, staticRenderFns } from "./Safepay.vue?vue&type=template&id=41a2d0b2&scoped=true"
import script from "./Safepay.vue?vue&type=script&lang=js"
export * from "./Safepay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a2d0b2",
  null
  
)

export default component.exports